

export const Logo = (props) => {
    return (
        <img style={{ width: "200px", height: "200px" }} src={props.src} alt="" className={props.class} />
    )
}